import { Component, Input, OnChanges } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { CellData, ColumnConfig, ColumnExtractor } from '@ddt-web/data-service';

@Component({
	selector: 'dcr-cell-content',
	templateUrl: './dcr-cell-content.component.html',
	styleUrls: ['./dcr-cell-content.component.scss']
})
export class DcrCellContentComponent implements OnChanges {
	public showEditor: boolean;

	@Input() public cell: CellData;
	@Input() public config: ColumnConfig<ColumnExtractor>;
	public key: string;
	public keyEdit: string;
	public infoBubble: string;
	public infoBubbleEdit: string;
	public value: string;
	public valueEdit: string;
	public dataPath: string;
	public dataPathEdit: string;

	constructor(public contentSvc?: ContentService) {
		this.showEditor = contentSvc ? contentSvc.showEditor : false;
	}

	public ngOnChanges(): void {
		try {
			if (this.showEditor) {
				if (this.cell && this.cell.config) {
					this.config = this.cell.config;
					if (this.cell.valueTranslation && this.cell.valueTranslation.key) {
						this.value = this.cell.valueTranslation.key;
						this.valueEdit = this.cell.valueTranslation.editLink + '#key=' + this.value;
					}
				}
				if (this.config) {
					if (this.config.label) {
						this.key = this.config.label.key;
						this.keyEdit = this.contentSvc.resolve(this.key, '').editLink + '#key=' + this.key;
					}
					if (this.config.infoBubble) {
						this.infoBubble = this.config.infoBubble.key;
						this.infoBubbleEdit = this.contentSvc.resolve(this.infoBubble, '').editLink + '#key=' + this.infoBubble;
					}

					if (this.config.extractor) {
						this.dataPath = this.cell?.config?.extractor.getDataPointPath() ?? this.config.extractor.getDataPointPath();
						this.dataPathEdit = this.contentSvc.resolve(this.dataPath, '').editLink + '#key=' + this.dataPath;
					}
				}
			}
		} catch (e) {
			console.warn('Issue with content edit mode', e);
		}
	}
}
